/* eslint-disable prettier/prettier */

// library imports
import * as React from "react";
import { Grid } from "@mui/material";

// component imports
import { useHistory } from "react-router-dom";
import PatientTable from "./PatientTable";

interface Props {
  csrfToken: string;
  menu_track_src: string;
  sort_plain_src: string;
  sort_ascending_src: string;
  sort_descending_src: string;
  chat_icon_with_orange_line: string;
  the_wall_icon_grey: string;
  pencil_grey: string;
  patient_reports_icon: string;
}

const PatientIndex: React.FC<Props> = (props: any) => {
  // other states
  const [selectedPatient, setSelectedPatient] = React.useState<any>(null);
  const [showEditForm, setShowEditForm] = React.useState<boolean>(false);
  const [unsaveChanges, setUnsavedChanges] = React.useState<boolean>(false);
  const [unsavedModalOpen, setUnsavedModalOpen] =
    React.useState<boolean>(false);
  const [privilegesModalOpen, setPrivilegesModalOpen] =
    React.useState<boolean>(false);
  const [renderingKey, setRenderingKey] = React.useState<number>(Math.random());

  // this state us used for pateint selection check when patient is changes on edit page
  const [tempSelectedPatient, setTempSelectedPatient] =
    React.useState<any>(null);

  const confirmOnSaveModal = () => {
    setSelectedPatient(tempSelectedPatient);
    setUnsavedModalOpen(false);
    setShowEditForm(false);
    setUnsavedChanges(false);
  };
  const history = useHistory();

  return (
    <div className="patient-container">

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container2"
				style={{ paddingRight: "24px" }}
      >
        <PatientTable
          csrfToken={props.csrfToken}
          menu_track_src={props.menu_track_src}
          sort_plain_src={props.sort_plain_src}
          sort_ascending_src={props.sort_ascending_src}
          sort_descending_src={props.sort_descending_src}
          selectedPatient={selectedPatient}
          setSelectedPatient={setSelectedPatient}
          setShowEditForm={setShowEditForm}
          setTempSelectedPatient={setTempSelectedPatient}
          unsaveChanges={unsaveChanges}
          setUnsavedModalOpen={setUnsavedModalOpen}
          renderingKey={renderingKey}
					patient_reports_icon={props.patient_reports_icon}
        />
      </Grid>
    </div>
  );
};

export default PatientIndex;
